import React, { Fragment, useEffect, useState } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import * as constants from '../../../utils/Constants'

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderColor: 'black',
        backgroundColor: '#3778C2',
        color: '#fff',
        border: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    invoiceContainer: {
        width: '100%',
        justifyContent: 'flex-start',
        marginTop: '5px',
        flexDirection: 'row',
        borderColor: 'black',
        color: 'black',
        border: 1,
        height: 150,
        textAlign: 'Left',
        fontStyle: 'bold',
        marginBottom: '10px'
    },
    invoice: {
        width: '50%',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        borderColor: 'black',
        color: 'black',
        border: 1,
        textAlign: 'Left',
        fontStyle: 'bold',
    },
    invoiceHeader: {
        backgroundColor: '#3778C2',
        textAlign: 'center',
        height: 20,
        color: '#fff',
        alignItems: 'center',
        marginBottom: 5,
        paddingTop: 2
    },
    item: {
        textAlign: 'left',
        paddingLeft: 8,
    },
    header: {
        width: '100%',
        flexGrow: 1,
        textAlign: 'center',
    },
    description: {
        width: '60%',
        borderRightColor: 'black',
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: 'black',
        borderRightWidth: 1,
    },
    rate: {
        width: '15%',
        borderRightColor: 'black',
        borderRightWidth: 1,
    },
    amount: {
        width: '15%'
    }
});



const InvoiceTableHeader = ({ items }) => {

    return (
        < Fragment >
            <View style={styles.container}>
                <Text style={styles.header}>{items.agentRegistration.gst ? 'Tax Invoice' : 'Invoice'}</Text>
            </View>
            <View style={styles.invoiceContainer}>
                <View style={styles.invoice}>
                    <View style={styles.invoiceHeader}>
                        <Text style={styles.header}>Details</Text>
                    </View>
                    <Text style={styles.item}>Invoice No: {items?.applyJob?.invoiceNumber || items.invoiceNumber}</Text>
                    <Text style={styles.item}>Invoice Date: {items?.applyJob?.invoiceDate || items.invoiceDate}</Text>
                    <Text style={styles.item}>Reverse Charge (Y/N): N</Text>
                    <Text style={styles.item}>State: {items.agentRegistration.state.stateName} </Text>
                    <Text style={styles.item}>State Code: {items.agentRegistration.state.stateCode}</Text>
                </View>
                <View style={styles.invoice}>
                    <View style={styles.invoiceHeader}>
                        <Text style={styles.header}>To</Text>
                    </View>
                    <Text style={styles.item}>Adhaan Solution Pvt Ltd</Text>
                    <Text style={styles.item}>712/712A, TIME SQUARE-1, OPP RAMBAUGH,</Text>
                    <Text style={styles.item}>NEAR BAGHABAN PARTY PLOT,</Text>
                    <Text style={styles.item}>THALTEJ SHILAJ ROAD, THALTEJ, </Text>
                    <Text style={styles.item}>AHMEDABAD - 380 059 (GUJARAT-INDIA)</Text>
                    <Text style={styles.item}>GSTIN: 24AAICA5878R1ZT</Text>
                </View>
            </View>
        </Fragment >
    )
};

export default InvoiceTableHeader;